import React, { Component } from 'react';
import * as Styles from './Styles';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../core/Store';
import Tab from './Tab';
import FileItem from './FileItem';
import SvgDownloadAll from '../../../others/svg_dist/DownloadAll';
import { filesMap } from './filesMap';

type State = {
	selectedTab: keyof typeof filesMap;
};

class FilePickerComponent extends Component<PropsFromRedux, State> {
	state: State = {
		selectedTab: 'info',
	};

	downloadAll = () => {
		const tempAnchor = document.createElement('a');
		tempAnchor.href = '/downloads/dokumenty-wopr.zip';
		tempAnchor.target = '_blank';
		tempAnchor.click();
	};

	switchTab = (targetTab: keyof typeof filesMap) => {
		this.setState({ ...this.state, selectedTab: targetTab });
	};

	render() {
		return (
			<Styles.FilePickerWrapper>
				<Styles.PickerTabsContainer>
					<Tab
						label="Dokumenty Informacyjne"
						onClick={() => this.switchTab('info')}
						active={this.state.selectedTab === 'info'}
					/>
					<Tab
						label="Program i Ogólne Warunki Ubezpieczenia"
						onClick={() => this.switchTab('owu')}
						active={this.state.selectedTab === 'owu'}
					/>
					<Tab
						label="Formularze"
						onClick={() => this.switchTab('forms')}
						active={this.state.selectedTab === 'forms'}
					/>
					<Styles.TabBlank />
				</Styles.PickerTabsContainer>
				<Styles.PickerContentWrapper>
					{filesMap[this.state.selectedTab].map((el) => {
						return (
							<FileItem
								key={el.title}
								Icon={el.icon}
								editDate={el.editDate}
								size={el.size}
								title={el.title}
								href={el.href}
							/>
						);
					})}
				</Styles.PickerContentWrapper>
				<Styles.PickerFoot>
					<Styles.DownloadAllButton
						onClick={() => this.downloadAll()}
					>
						<SvgDownloadAll />
						<p>pobierz wszystkie (.zip)</p>
					</Styles.DownloadAllButton>
				</Styles.PickerFoot>
			</Styles.FilePickerWrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const FilePicker = connector(FilePickerComponent);
export default FilePicker;
